module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_materials-d108c0f5eb38061748a7c06ca36dface.svg";